module.exports = __webpack_public_path__ + "img/logo_bing.f54ea81d.png";